var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wcc fields"},[_c('Field',{attrs:{"label":"Rate","boundData":_vm.commissionData.value.rate}}),(_vm.commissionData.value.bonus)?_c('Field',{attrs:{"label":"Bonus","boundData":_vm.commissionData.value.bonus}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }